export default __webpack_public_path__ + "static/media/Logo_210505.64c5bdd1.png";